import { EnumerationsServiceType } from 'client/identity'
import { getEnum } from '.'

export const getServiceNameForPaths = (
  serviceType: EnumerationsServiceType
): string | undefined => {
  switch (serviceType) {
    case EnumerationsServiceType.Compliance:
      return 'compliance'
    case EnumerationsServiceType.WorkforceAnalytics:
      return 'wfa'
    case EnumerationsServiceType.GoodFaithEfforts:
      return 'gfe'
    default:
      return getEnum(EnumerationsServiceType, serviceType)?.[0]?.toLowerCase()
  }
}
